export function scrollToElement(
  targetId: string,
  offset: number = 100, // positive → scroll a bit further down
): void {
  if (typeof window === "undefined") return;

  const targetElement = document.getElementById(targetId);
  if (!targetElement) return;

  const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;

  const finalPosition = Math.min(
    elementTop + offset,
    document.documentElement.scrollHeight - window.innerHeight,
  );

  window.scrollTo({
    top: finalPosition,
    behavior: "smooth",
  });
}

export function useScrollToContact() {
  return () => scrollToElement("contact-main", -100);
}

export function useScrollToCareerForm() {
  return () => scrollToElement("career-form", -100);
}
